<template>
    <div>
        <div class="shopping-info-page">
            <div class="page_top">
                <div class="title" @click="back()">
                    <i class="icon" id="icon"></i>
                    <span class="header-text">購物車</span>
                </div>
            </div>

            <div class="page_padding">
                <div class="row">
                    <div class="col my-4">
                        <div class="bg-white shadow rounded  mx-2 p-2">
                            <el-steps :active="active" finish-status="success" align-center>
                                <el-step title="確認訂單"></el-step>
                                <el-step title="確認資料"></el-step>
                                <el-step title="付款"></el-step>
                                <el-step title="完成訂單"></el-step>
                            </el-steps>
                        </div>
                    </div>

                </div>
                <el-form ref="form" :model="form" label-width="80px" :rules="rules" size="small">
                    <div class="mx-2 bg-white shadow ">
                        <div class="row  mx-2">
                            <div class="col-12">
                                <el-divider content-position="left"><span class="fw-bold">購買人資訊</span></el-divider>
                                <el-form-item label="姓名" prop="buyInfo.name">
                                    <el-input v-model="form.buyInfo.name" placeholder="姓名"></el-input>
                                </el-form-item>
                                <el-form-item label="聯絡電話" prop="buyInfo.phone">
                                    <el-input type="number" v-model="form.buyInfo.phone" placeholder="連絡電話"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="row mx-2">
                            <el-divider content-position="left"><span class="fw-bold">發票寄送資訊</span></el-divider>
                            <el-form-item label="縣/市" prop="buyInfo.city">
                                <el-select v-model="form.buyInfo.city" placeholder="地區">
                                    <el-option label="高雄市" value="1"></el-option>
                                    <el-option label="台北市" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="鄉鎮市區" prop="buyInfo.area">
                                <el-select v-model="form.buyInfo.area" placeholder="鄉鎮市區">
                                    <el-option label="大寮區" value="1"></el-option>
                                    <el-option label="小港區" value="2"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="地址" prop="buyInfo.address">
                                <el-input v-model="form.buyInfo.address" placeholder="地址"></el-input>
                            </el-form-item>
                        </div>
                        <div class="row  mx-2">
                            <div class="col-12 ">
                                <el-divider content-position="left"><span class="fw-bold">配送資訊</span></el-divider>
                                <el-row class="mb-3">
                                    <el-checkbox label="與購買人資訊相同" name="type"></el-checkbox>
                                </el-row>
                                <el-form-item label="姓名" prop="sendInfo.name">
                                    <el-input v-model="form.sendInfo.name" placeholder="姓名"></el-input>
                                </el-form-item>
                                <el-form-item label="聯絡電話" prop="sendInfo.phone">
                                    <el-input v-model="form.sendInfo.phone" placeholder="連絡電話"></el-input>
                                </el-form-item>
                                <el-form-item label="縣/市" prop="sendInfo.city">
                                    <el-select v-model="form.sendInfo.city" placeholder="縣市">
                                        <el-option label="高雄市" value="1"></el-option>
                                        <el-option label="台北市" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="鄉鎮市區" prop="sendInfo.area">
                                    <el-select v-model="form.sendInfo.area" placeholder="鄉鎮市區">
                                        <el-option label="大寮區" value="1"></el-option>
                                        <el-option label="小港區" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="地址" prop="sendInfo.address">
                                    <el-input v-model="form.sendInfo.address" placeholder="地址"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="row  mx-2">
                            <div class="col-12 my-4 justify-content-center d-flex">
                                <el-checkbox label="記錄相關資訊下次使用" name="type" v-model="remeber"></el-checkbox>
                            </div>
                        </div>
                    </div>

                </el-form>
            </div>
        </div>
        <div class=" position-fixed w-100 bg-white  " style="bottom: 0px;height: 70px;">
            <div class="d-flex justify-content-center align-items-center h-100 ">
                <el-button type="danger" @click="submit" class="w-75">結帳</el-button>
            </div>
        </div>
    </div>

</template>
<script>


    export default {
        components: {},
        mixins: [],
        data() {
            return {
                remeber: true,
                active: 1,
                form: {
                    buyInfo: {
                        name: "irvin",
                        phone: "0987654321",
                        city: "1",
                        address: "大寮區內坑路168-1號",
                        area:"1",
                    },
                    sendInfo: {
                        name: "irvin",
                        phone: "0987654321",
                        city: "1",
                        address: "大寮區內坑路168-1號",
                        area:"1",
                    },
                    // buyInfo: {
                    //     name: "",
                    //     phone: "",
                    //     city: "",
                    //     address: "",
                    // },
                    // sendInfo: {
                    //     name: "",
                    //     phone: "",
                    //     city: "",
                    //     address: "",
                    // },
                },
                rules: {
                    buyInfo: {
                        name: [
                            {required: true, message: '請輸入姓名', trigger: 'blur'},
                        ],
                        phone: [
                            {required: true, message: '請輸入聯絡電話', trigger: 'blur'},
                        ],
                        city: [
                            {required: true, message: '請選擇縣/市', trigger: 'change'},
                        ],
                        area: [
                            {required: true, message: '請選鄉鎮市區', trigger: 'change'},
                        ],
                        address: [
                            {required: true, message: '請輸入地址', trigger: 'blur'},
                        ],
                    },
                    sendInfo: {
                        name: [
                            {required: true, message: '請輸入姓名', trigger: 'blur'},
                        ],
                        phone: [
                            {required: true, message: '請輸入聯絡電話', trigger: 'blur'},
                        ],
                        city: [
                            {required: true, message: '請選擇縣/市', trigger: 'change'},
                        ],
                        area: [
                            {required: true, message: '請選鄉鎮市區', trigger: 'change'},
                        ],
                        address: [
                            {required: true, message: '請輸入地址', trigger: 'blur'},
                        ],
                    },

                },


            }
        },
        mounted() {
        },
        methods: {
            back() {
                this.$router.go(-1)
            },
            submit() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$router.push({name: 'StoreComplete'})

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }

        }
    }
</script>




